import { defineMessages } from "react-intl";

export const commonPalletDiscrepancyLabels = defineMessages({
  palletDiscrepancy: {
    id: "commonPalletDiscrepancy.palletDiscrepancy",
    defaultMessage: "PALLET DISCREPANCY",
  },
  shipmentContents: {
    id: "commonPalletDiscrepancy.shipmentContents",
    defaultMessage: "Shipment contents",
  },
  shipmentContentsTooltip: {
    id: "commonPalletDiscrepancy.shipmentContentsTooltip",
    defaultMessage: "Pallet details are supplied by Flexport, while box information comes from the shipping plan",
  },
  boxes: {
    id: "commonPalletDiscrepancy.boxes",
    defaultMessage: "{count, plural, =1 {# box} other {# boxes}}",
  },
  expectedBoxes: {
    id: "commonPalletDiscrepancy.expectedBoxes",
    defaultMessage: "{count, plural, =1 {# expected box} other {# expected boxes}}",
  },
});
